import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from './constants/routes';
import { lazy } from 'react';
import PublicRoute from '../components/common/PublicRoute';
import PrivateRoute from '../components/common/PrivateRoute';
import { WebSocketProvider } from '../services/socket/socketContext';
const Dashboard = lazy(() => import('../Pages/dashboard'));
const Layout = lazy(() => import('../components/layout'));
const Login = lazy(() => import('../Pages/login'));

const Routing = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<PublicRoute />}>
        <Route path={ROUTES.signIn} element={<Login />} />
        {/* <Route path="/signup" element={<Signup />} /> */}
      </Route>

      {/* Private routes */}
      <Route element={<PrivateRoute />}>
        <Route
          element={
            <WebSocketProvider>
              <Layout />
            </WebSocketProvider>
          }
        >
          <Route path={ROUTES.default} element={<Dashboard />} />
        </Route>
        {/* Add more protected routes here */}
      </Route>
      <Route path="*" element={<Navigate replace to={ROUTES.default} />} />
    </Routes>
  );
};
export default Routing;
